// extracted by mini-css-extract-plugin
export var modal = "_dk-0";